var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+" Safety Codes Council\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }